module.exports = __webpack_public_path__ + "static/media/undraw_super_thank_you_obwk.0bea8741.svg";